import { indexTree } from "app/pages/sales-intelligence/utils/taxonomy-tree/tree";
import type { TaxonomyNode } from "app/pages/sales-intelligence/utils/taxonomy-tree/types";

import type { TechnologiesDescriptionDto } from "../types/dto";
import type { TechnologyNodeId, TechnologyTaxonomyIndex } from "../types/taxonomy";
import { createTechnologyNodeId } from "../types/taxonomy";

/**
 * Builds the technology description into the generic taxonomy tree.
 *
 * The nesting — categories, sub-categories, technologies — is technology's own shape, so consumers get
 * it from here rather than reaching into the DTO themselves and breaking when it moves. The wire
 * carries stable ids only on leaves, so whole-tree ids are synthesized positionally.
 */
export const buildTechnologyTaxonomyTree = (
    dto: TechnologiesDescriptionDto,
): readonly TaxonomyNode<TechnologyNodeId>[] =>
    dto.technologies.map((category, categoryIndex) => ({
        id: createTechnologyNodeId([categoryIndex]),
        name: category.name,
        children: category.categories.map((subCategory, subCategoryIndex) => ({
            id: createTechnologyNodeId([categoryIndex, subCategoryIndex]),
            name: subCategory.name,
            children: subCategory.technologies.map((technology, technologyIndex) => ({
                id: createTechnologyNodeId([categoryIndex, subCategoryIndex, technologyIndex]),
                name: technology.name,
                children: [],
            })),
        })),
    }));

export const indexTechnologyTaxonomy = (dto: TechnologiesDescriptionDto): TechnologyTaxonomyIndex =>
    indexTree(buildTechnologyTaxonomyTree(dto));
